import FocusTrap from "./FocusTrap";
export { useFocusTrap } from "./FocusTrap";
export default FocusTrap;